"use client";
import React from "react";
import { Link, useParams } from "react-router-dom";

const sampleBlogs = [
  {
    id: 1,
    title: "What is Dynamic Island Apple – A 2024 Guide",
    category: { name: "UI/UX" },
    slug: "dynamic-island-guide",
    author: { name: "Nida" },
    description: "A guide on Dynamic Island for iOS18 users.",
    publishedAt: "2024-11-08",
    blog_image: { url: "/images/dynamic.jpg" },
  },
  {
    id: 2,
    title: "Mastering Visual Hierarchy in UX",
    category: { name: "3D Motion" },
    slug: "visual-hierarchy-ux",
    author: { name: "Zain" },
    description: "Explore how to guide users visually...",
    publishedAt: "2024-11-01",
    blog_image: { url: "/images/visual.jpg" },
  },
  {
    id: 3,
    title: "Mastering Visual Hierarchy in 3D Motion",
    category: { name: "Video" },
    slug: "3d-motion-visual",
    author: { name: "Shahzaib" },
    description: "Explore how to guide users visually in motion...",
    publishedAt: "2024-11-01",
    blog_image: { url: "/images/motion.jpg" },
  },
];

const Categories = () => {
  const { slug } = useParams();
  const decodedSlug = decodeURIComponent(slug || "");

  const filteredBlogs = sampleBlogs.filter((post) => {
    if (!decodedSlug) return true;
    return (
      post.category.name.toLowerCase().includes(decodedSlug.toLowerCase()) ||
      post.title.toLowerCase().includes(decodedSlug.toLowerCase())
    );
  });

  if (filteredBlogs.length === 0) {
    return (
      <div
        className="container mt-5"
        style={{ maxWidth: "100%", justifyContent: "center", display: "flex" }}
      >
        <img src="/images/not-found.png" alt="Not Found" />
      </div>
    );
  }

  return (
    <>
      <title>MediaDunes | Blogs</title>
      <section className="section mt-70">
        <div className="cnt-center container">
          <div className="row flex justify-evenly gap-2">
            {filteredBlogs.map((post) => (
              <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={post.id}>
                <div className="card h-100 shadow-sm">
                  <img
                    src={post.blog_image.url}
                    className="card-img-top"
                    alt={post.title}
                  />
                  <div className="card-body d-flex flex-column">
                    <h5 className="card-title">{post.title}</h5>
                    <p className="card-text">{post.description}</p>
                    <p className="card-meta text-muted">
                      {new Date(post.publishedAt).toLocaleDateString()} |{" "}
                      {post.author?.name}
                    </p>
                  </div>
                  <Link to={`/blogs/${post.slug}`} className="btn btn-primary m-2">
                    Read More
                  </Link>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Categories;
